export default {
    videoSpeaker: {
        index01: 'Video Speaker',
    },
    // 公共
    common: {
        cancel: 'Cancel',
        del: 'Confirm',
    },
    //登录页面
    login: {
        welcomeUseAIBot: 'Welcome to AI Treasure Box',
        useCode: 'Phone Login',
        useUserName: 'Account Login',
        pleaseSetIphone: 'Please enter your Hong Kong mobile number (without 852 prefix)',
        pleaseSetCode: 'Please enter verification code',
        getCode: 'Get verification code',
        noAccount: 'No account?',
        register: 'Sign up now',
        pleaseSetPassword: 'Please enter password',
        login: 'Login',
        pleaseAgreeXieYi: 'Please accept the agreement',
        alsoRead: 'I have read and agree to the',
        and: 'and',
        userAgreement: 'User Agreement',
        privacyPolicy: 'Privacy Policy',
        forgetPassWord: 'Forgot Password',
        resetPassWord: 'Reset Password',
        pleaseSetPassWord: 'Please enter password',
        againPleaseSetPassWord: 'Re-enter password',
        noResetPassWord: `Don\'t need to reset?`,
        nowLogin: 'Login immediately',
        confirm: 'Confirm',
        firstTimeLogin: 'Set Password on First Login',
        pleaseEnterMessage: 'Complete Verification',
        pleaseSliderRight: 'Slide to Verify',
        messageFail:'Verification Failed',
        messageSuccess:'Verification Successful',
        jiekouFiale: 'Too Many Failures, Try Again Later',
    },
    // 我的资产
    userInfoMesssage:{
        tipsleft:'Files are stored for at least ',
        tipsRighr:'hour. Please be sure to download in time'
    },
    // 网站首页
    homePage: {
        slogan1: 'Experience New AI Tech Tools',//体验全新AI科技工具
        slogan2: 'Unleash AI Creativity, Ignite Infinite Possibilities',//释放AI创作灵感，激发无限创意可能
        slogan3: 'Try it now',//立即体验
        ALTreasureChest: 'AI Treasure Box',//AI百宝箱
        greetings: 'Get What You Imagine',//助你所想即所得
        descrWords: 'Intelligently interprets your needs, creates masterpieces in one click',//智能解析所想，一键生成佳作
        inspirationPictures: 'Inspiration Images',//灵感图片
        specialEffectsVideo: 'Special Effects Videos',//特效视频
        intelligentDialogue: 'AI Dialogue',//智能对话
        AIPPT: 'Al PPT',//Al PPT
        digitalHuman: 'Digital Human',//数字人
        explore: 'Explore',//探索
        quickLogin: 'Login',//快速登录
        myCount: 'My Account',
        myAssets: 'My Assets',
        loGout: 'Log out',
        totalPoInTs: 'Total AI Points',
        totalEarned: 'Total Earned',
        totalSpent: 'Total Spent',
        AIPoInTsNotEnough: 'Need more AI Points? Top up to get more',
        Recharge: 'Recharge',
        spent: 'Spent',
        earn: 'Earn',
        Date: 'Date',
        earnedAIPoints: 'AI Points Earned',
        MobileNumber: 'Mobile Number',
        tools:'Tool',
        Source: 'Source',
        spentAIPoints: 'AI Points Spent',
        allToTalPoints: 'Total AI Points',
        onlyThirtyMessage: 'Only records from the past 60 days are displayed. No records available.',
        sureDel: 'Delete Asset',
        delInfo: 'This cannot be recovered after deletion. Are you sure you want to delete?',
        all: 'All',
        Images: 'Images',
        Videos: "Videos",
        footer:'© 2025 China Mobile Hong Kong Company Limited. All rights reserved',//© 2025 中国移动香港有限公司版权所有
        nothing:'No assets at the moment',//暂无资产
    },
    //支付页
    Payment: {
        headline: 'Get more AI point by recharging',//通过充值获得更多灵感点
        subheading: 'Please note: AI point are non-transferable, non-refundable, and cannot be withdrawn or exchanged for cash.',//温馨提醒：灵感点不可转赠或提现，不支持退换货或反向兑换提现
        canGenerate: 'Can generate',//可生成
        inspirationPictures: 'inspiration images',//张灵感图片
        specialEffectsVideo: 'special effect videos',//个特效视频
        intelligentDialogue: ' characters of AI Dialogue',//字智能对话
        AIPPT: 'AI PPTs',//个AI PPT
        digitalHuman: 'digital human videos',//个数字人视频
        pay: 'Payment',//支付
    },
    //支付结果查询页
    RechargeInquiry: {
        topUpSuccessful: 'Recharge Successful',//充值成功
        topUpFailed: 'Recharge failed',//充值失败
    },
    //AI对话
    AIDialog:{
        nowToalking:'Recent Chats',
        welcome:'Welcome to ',
        intelligentDialogue:'AI Dialogue',// 智能对话
        startConversation:'New chat',// 开启新对话
        helpTips:'Need help? Feel free to ask.',// 需要帮助？尽管提问
        pleaseEnterMessage:'Type a message...',// 请输入消息
        deepThinking:'DeepTink',// 深度思考
        newConversation:'New chat',// 新对话
        switchModel:'switch model',//切换模型
        Rename:'Rename',//重命名
        delete:'Delete',//删除
    },
    // 视频特效模板
    effectsTemplate:{
        selectTemplate:'Select special effects template',
        clickReplace:'click to replace ',
        UploadImage:'Upload Image',
        texiao:"Creative Effects",
        WelcomeUse:'Welcome to',
        EnhanceEffects:'Enhance Effects',
        CreativeRender:'Creative Render',
        all:'All',//全部
        fun:'Fun',//趣味
        transform:'Transform',//变身
        creativity:'Creativity',//创意
        doll:'Transforming Doll',// 变身玩偶
        pig:'Summon Mount - Pig',// 召唤坐骑 - 猪
        tiger:'Summon Mount - Tiger',// 召唤坐骑 - 老虎
        dragon:'Summon Mount - Dragon',// 召唤坐骑 - 龙
        ikebana:'All things bloom',// 万物生花
        hug:'Embrace',// 拥抱
        embraceLove:'Loving Hug ',// 爱的拥抱
        manyWomen:'Surrounded by beautiful women',// 美女环绕
        manyHandsome:'Surrounded by handsome guys',// 帅哥环绕
        baby:'Divinely Blessed Baby',// 天赐宝宝
        emo:'emoji character transformation',// emoji小人变身
        dreamyDoll:'Dream Doll Transformation',// 梦幻娃娃变身
        babyCamera:'Baby Camera',// 娃娃照相机
        worldWind:'My World Style',// 我的世界风
        crystalBall:'Put it into the crystal ball',// 装进水晶球
        catStarPeople:'Guardians of Cat People',// 猫星人的守护
        angelFigurine:'Angel figurine transformation',// 天使手办变身
        felt:'Felt keychain transformation ',// 毛毡钥匙扣变身
        acrylic:'Acrylic pendant transformation',// 亚克力挂饰变身
        instantCamera:'Polaroid style',// 拍立得风
        collectibleToy:'Transformation of trendy toy figurines',// 潮玩手办变身
        tips01:'Click to select a template in the first area, and click to upload an image in the second area.',
        uploadCheck:'Please upload a JPG or PNG image (recommended under 5 MB).'
    },
}
